module.exports = __webpack_public_path__ + "img/icon-songoroo-white.7cef2810.svg";